import { createStore, combineReducers } from 'redux';

import { WindowProxy } from '@sm360/widget-commons-core-services';
import { accountReducer } from '@sm360/widget-commons-general';

/* eslint no-underscore-dangle: 0 */

export default function configureStore() {
    const rootReducer = combineReducers({
        account: accountReducer,
    });

    const $window = WindowProxy.get();
    const extension = $window && $window.__REDUX_DEVTOOLS_EXTENSION__ && $window.__REDUX_DEVTOOLS_EXTENSION__();
    const store = createStore(rootReducer, extension);

    return store;
}
